import React from 'react';
import { useController, Control, ControllerProps } from 'react-hook-form';
import { Textarea as BaseTextarea } from 'components/ui';

interface FormTextareaProps {
  name: string;
  control: Control<any>;
  label?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  rows?: number;
  rules?: ControllerProps['rules'];
}

const FormTextarea: React.FC<FormTextareaProps> = ({
  name,
  control,
  label,
  placeholder,
  className,
  disabled = false,
  rows = 3,
  rules
}) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    name,
    control,
    rules
  });

  return (
    <BaseTextarea
      {...field}
      label={label}
      placeholder={placeholder}
      error={error?.message}
      disabled={disabled}
      rows={rows}
      className={className}
    />
  );
};

export { FormTextarea };